/* eslint implicit-arrow-linebreak: 0 */

import { defaultMemoize } from 'reselect';
import _find from 'lodash/find';
export var getSelectedFilterGroup = defaultMemoize(function (selFilterGroupId, filterGroups) {
  return _find(filterGroups, {
    id: selFilterGroupId
  });
});